export interface AiOperationCosts {
  extract_job_competencies: number;
  generate_job_description: number;
  extract_culture_competencies: number;
}

export const DEFAULT_AI_OPERATION_COSTS: AiOperationCosts = {
  extract_job_competencies: 1,
  generate_job_description: 1,
  extract_culture_competencies: 8
};

const parseCost = (
  value: number | string | null | undefined,
  fallback: number
): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const parseAiOperationCosts = (
  costs:
    | Partial<Record<keyof AiOperationCosts, number | string>>
    | null
    | undefined
): AiOperationCosts => ({
  extract_job_competencies: parseCost(
    costs?.extract_job_competencies,
    DEFAULT_AI_OPERATION_COSTS.extract_job_competencies
  ),
  generate_job_description: parseCost(
    costs?.generate_job_description,
    DEFAULT_AI_OPERATION_COSTS.generate_job_description
  ),
  extract_culture_competencies: parseCost(
    costs?.extract_culture_competencies,
    DEFAULT_AI_OPERATION_COSTS.extract_culture_competencies
  )
});
